var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserBasic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.768 14.914a7.304 7.304 0 00-1.575-2.334 7.336 7.336 0 00-2.334-1.574l-.023-.01A4.843 4.843 0 0010 2.226a4.843 4.843 0 00-2.836 8.772l-.023.01c-.875.369-1.66.898-2.334 1.574a7.337 7.337 0 00-2.15 5.031.156.156 0 00.156.16h1.171a.156.156 0 00.157-.152 5.823 5.823 0 011.715-3.99A5.82 5.82 0 0110 11.914a5.82 5.82 0 014.145 1.717 5.823 5.823 0 011.714 3.99c.002.086.07.152.157.152h1.172a.157.157 0 00.156-.16 7.277 7.277 0 00-.576-2.699zM10 10.43c-.896 0-1.74-.35-2.375-.985a3.338 3.338 0 01-.984-2.375c0-.896.35-1.74.984-2.375A3.338 3.338 0 0110 3.711c.896 0 1.74.35 2.375.984.635.635.984 1.479.984 2.375 0 .897-.35 1.74-.984 2.375A3.337 3.337 0 0110 10.43z",
    fill: "#85A5FF"
  })));
}

export default __webpack_public_path__ + "./fonts/user-basic.9b9b24fc3796b86951d4bcbe8f73fdf1.svg";
export { SvgUserBasic as ReactComponent };